<template>
  <div class="notice-detail">
    <div class="notice-header">
      <h2 class="notice-title">{{ notice.title }}</h2>
      <div class="notice-meta">
        <span class="meta-item">작성자 : 관리자 </span>
        <span class="meta-item">등록일 : {{ formatDate(notice.createdAt) }}</span>

        <!-- ───── 첨부파일 드롭다운 ───── -->
        <div v-if="hasFiles" class="file-dropdown-wrapper">
          <button class="file-dropdown-btn" @click="toggleDropdown">
            첨부파일
            <span :class="{ 'arrow-up': showFiles, 'arrow-down': !showFiles }"></span>
          </button>
          <transition name="dropdown">
            <ul v-show="showFiles" class="file-dropdown-list">
              <!-- <li v-for="(url, name) in notice.fileUrl" :key="name">
                <a :href="getDownloadLink(url)"
                   :download="name"
                   target="_blank">
                  <span class="file-icon">{{ getFileIcon(name) }}</span>
                  {{ name }}
                </a>
              </li> -->
              <li v-for="(url, name) in notice.fileUrl" :key="name">
                <a
                  :href="getDownloadLink(url)"
                  :download="name"
                  target="_blank"
                  rel="noopener"            
                  class="file-link"
                >
                  <span class="file-icon">{{ getFileIcon(name) }}</span>
                  <span class="file-name">{{ name }}</span>
                  <span class="file-tooltip" role="tooltip">{{ name }}</span>
                </a>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
    
    <div class="notice-content" v-html="notice.content"></div>

    <div class="button-area">
      <router-link to="/notice" class="list-button">목록</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import axios from '@/utils/axios';

/* ───── 상태 ───── */
const notice    = ref({});
const showFiles = ref(false);
const route     = useRoute();


/* ───── 헬퍼 ───── */
const getFileIcon = (name) => {
  const ext = name.split('.').pop().toLowerCase();
  switch (ext) {
    case 'pdf': return '📄';
    case 'jpg': case 'jpeg': case 'png': case 'gif': return '🖼';
    case 'xlsx': case 'xls': return '📊';
    case 'doc': case 'docx': return '📃';
    case 'zip': case '7z': case 'rar': return '🗜';
    case 'hwp': return '📝';
    default:    return '📁';
  }
};

const getDownloadLink = (filePath) => {
  const filename = filePath.split(/\\|\//).pop();
  return `/bx201/download/${encodeURIComponent(filename)}`;
};

// 날짜 포맷 함수
const formatDate = (dateString) => {
  const date = new Date(dateString);  // Date 객체로 변환
  if (isNaN(date)) return "";  // 잘못된 날짜일 경우 빈 문자열 반환

  // 연, 월, 일을 추출하여 "yyyy-MM-dd" 형식으로 포맷
  const year = date.getFullYear(); // 연도
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1), 두 자릿수로 포맷
  const day = String(date.getDate()).padStart(2, '0'); // 일, 두 자릿수로 포맷
  
  return `${year}-${month}-${day}`;
};

/* ───── Computed ───── */
const hasFiles = computed(() =>
  notice.value.fileUrl && Object.keys(notice.value.fileUrl).length > 0
);

/* ───── 이벤트 ───── */
const toggleDropdown = () => { showFiles.value = !showFiles.value; };

/* ───── mounted ───── */
onMounted(() => {
  axios.get(`/bx201/notice/${route.params.id}`)
    .then(({ data }) => (notice.value = data));
});


</script>

<style scoped>
.notice-detail {
  max-width: 1200px;
  margin: 50px auto;
  padding: 0;
  background-color: #fff;
  font-family: 'Noto Sans KR', sans-serif;
}

.notice-header {
  border-top: 2px solid #333;
  border-bottom: 1px solid #ddd;
  padding: 20px 15px;
}

.notice-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0 0 15px 0;
}

.notice-meta {
  display: flex;
  color: #888;
  font-size: 14px;
}

.meta-item {
  margin-right: 20px;
}

.notice-content {
  min-height: 300px;
  padding: 30px 15px;
  line-height: 1.8;
  color: #555;
  font-size: 15px;
  border-bottom: 1px solid #ddd;
}

.button-area {
  margin-top: 30px;
  text-align: center;
}

.list-button {
  display: inline-block;
  padding: 10px 30px;
  background-color: #666;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  border-radius: 0;
  transition: background-color 0.3s;
}

.list-button:hover {
  background-color: #444;
}

.notice-content img,
.resource-content img {
  max-width: 100%;
  height: auto;
  display: block;
  /* 아래는 선택사항 */
  margin: 10px auto;
  /* 이미지가 너무 작을 때는 최소 폭 보장 (선택) */
  min-width: 0;
  /* 둥글게, 그림자 등 부가 옵션도 추가 가능 */
  /* border-radius: 8px; */
}

/* 파일 드롭다운 스타일 & 애니메이션 */
.file-dropdown-wrapper  { margin-left:auto; position:relative; min-width:100px; }
.file-dropdown-btn      { background:#eee; border:none; color:#444; padding:6px 18px 6px 12px; border-radius:4px; font-size:14px; cursor:pointer; transition:background .2s; }
.file-dropdown-btn:hover{ background:#e0e0e0; }
.arrow-down,.arrow-up   { display:inline-block; margin-left:6px; width:0;height:0; border-left:6px solid transparent; border-right:6px solid transparent; }
.arrow-down             { border-top:7px solid #666; }
.arrow-up               { border-bottom:7px solid #666; }

.file-dropdown-list { list-style:none; position:absolute; top:36px; right:0; background:#fff; border:1px solid #ddd; border-radius:8px; min-width:120px; max-width:360px; padding:10px 0; margin:0; z-index:100; box-shadow:0 2px 10px rgba(0,0,0,.13); }
.file-dropdown-list li{ margin:0;padding:0; }
/* a 자체는 넘침을 숨길 필요 없음 */
.file-dropdown-list a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #007bff;
  padding: 7px 24px 7px 16px;
  text-decoration: none;
  font-size: .97rem;
  transition: background .18s;
  max-width: 320px;
  white-space: nowrap;   /* 유지 */
  overflow: visible;     /* ⬅️ 변경: 숨기지 말고 자식에서 처리 */
  text-overflow: clip;   /* ⬅️ 선택: a에서는 ellipsis 미사용 */
}
.file-dropdown-list a:hover{ background:#f2f6fa; color:#0056b3; }
.file-icon           { font-size:1.13em; min-width:1.4em; text-align:center; }

.dropdown-enter-active,
.dropdown-leave-active { transition:opacity .18s; }
.dropdown-enter-from,
.dropdown-leave-to     { opacity:0; }
.dropdown-enter-to,
.dropdown-leave-from   { opacity:1; }

/* 2) 텍스트는 항상 말줄임표 (flex 컨테이너 호환) */
.file-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* 1) a는 툴팁의 기준점이 되도록 */
.file-dropdown-list a.file-link {
  position: relative;
  overflow: visible; /* 툴팁이 밖으로 나올 수 있게 */
}

/* 3) 툴팁 기본: 숨김 */
.file-tooltip {
  position: absolute;
  left: 16px;                 /* 아이콘 오른쪽 정도에서 시작 */
  bottom: calc(100% + 8px);   /* 링크 위쪽에 띄우기; 아래로 띄우려면 top: calc(100% + 8px) */
  max-width: 540px;           /* 원하는 최대폭 */
  padding: 8px 10px;
  background: #fff;
  color: #333;
  font-size: .95rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,.12);
  white-space: nowrap;        /* 한 줄로 전체 표시 */
  z-index: 1000;

  pointer-events: none;       /* 마우스 올려도 깜빡임 방지 */
  opacity: 0;
  transform: translateY(4px);
  transition: opacity .12s ease, transform .12s ease;
  display: block;             /* 애니메이션 위해 block 유지 */
}

/* 4) 호버 시 툴팁 표시 */
.file-link:hover .file-tooltip {
  opacity: 1;
  transform: translateY(0);
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .notice-detail {
    margin: 30px auto;
    padding: 0 15px;
  }
  
  .notice-title {
    font-size: 16px;
  }
  
  .notice-meta {
    flex-direction: column;
  }
  
  .meta-item {
    margin-bottom: 5px;
  }
  
  .notice-content {
    padding: 20px 0;
    min-height: 200px;
  }
}
</style>